import { render, staticRenderFns } from "./DatetimePickerLocale.vue?vue&type=template&id=5975e52e&"
import script from "./DatetimePickerLocale.vue?vue&type=script&lang=js&"
export * from "./DatetimePickerLocale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports